import PropTypes from 'prop-types';
import React, { Children } from 'react';
import clsx from 'clsx';

/**
 *  The BoxGrid component takes children and wraps them in a grid based on columnCount
 *  and spans the last (or only) item across the entire width if it is orphaned
 *
 */
function BoxGrid(_ref) {
  let {
    children,
    className,
    columnCount = 2,
    dataCmp = 'boxGrid',
    includeXs = false,
    ...rest
  } = _ref;
  const boxes = Children.toArray(children);

  // If we have an uneven number of boxes, add grid-spanning styling
  if (boxes.length % columnCount === 1) {
    boxes.push(
    /*#__PURE__*/
    // Cloned to preserve its ref
    React.cloneElement(boxes.pop(), {
      style: {
        gridColumnStart: 1,
        gridColumnEnd: -1
      }
    }));
  }
  return !!boxes.length && /*#__PURE__*/React.createElement("div", Object.assign({
    className: clsx('box-grid', `box-grid-col-${includeXs ? '' : 'sm-'}${columnCount}`, className),
    "data-cmp": dataCmp
  }, rest), boxes.map(box => box));
}
export default BoxGrid;